import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from 'src/App.tsx'

import { UserContextProvider } from 'utils/userContext'

import 'assets/fonts/fonts.scss'
import 'src/main.scss'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </BrowserRouter>
)
